let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gUnRt")).then(() => parcelRequire('c4im9'));